module.exports = __webpack_public_path__ + "static/media/payment.da381f57.svg";